export enum EventTypes {
	Interaction = 'interactionEvent',
	Error = 'errorEvent',
	Transaction = 'transaction',
	Checkout = 'checkout',
	CheckoutOption = 'checkoutOption',
	InternalEvent = 'internal_event',
	StateOfCart = 'State of Cart'
}
